import React, { useEffect } from 'react';
import '../BunnyStyles.css';
import BunnyHeader from '../components/bunny/BunnyHeader';
import BunnyHeroSection from '../components/bunny/BunnyHeroSection';
import BunnyAboutSection from '../components/bunny/BunnyAboutSection';
import BunnyProductSection from '../components/bunny/BunnyProductSection';
import BunnyPhilosophySection from '../components/bunny/BunnyPhilosophySection';
import BunnyTestimonialSection from '../components/bunny/BunnyTestimonialSection';
import BunnySisterBrandSection from '../components/bunny/BunnySisterBrandSection';
import BunnyFAQSection from '../components/bunny/BunnyFAQSection';
import BunnyFinalCTASection from '../components/bunny/BunnyFinalCTASection';
import BunnyFooter from '../components/bunny/BunnyFooter';

const WaistedBunny = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <BunnyHeader />
      <main>
        <BunnyHeroSection />
        <BunnyAboutSection />
        <BunnyProductSection />
        <BunnyPhilosophySection />
        <BunnyTestimonialSection />
        <BunnySisterBrandSection />
        <BunnyFAQSection />
        <BunnyFinalCTASection />
      </main>
      <BunnyFooter />
    </div>
  );
};

export default WaistedBunny;
